import Icon from "./Icon";
import {faWarning} from "@fortawesome/free-solid-svg-icons";

/**
 * An error card.
 *
 * -- Props --
 * | Name       | Type      | Required  | Default Value | Description
 * |------------|-----------|-----------|---------------|---------------
 * | title      | string    | false     | ""            | The modal title
 */
export const ErrorCard = (props) => {
  return (
      <div className="card has-background-danger-light">
        <div className="card-content">
          <div className="content">
            <Icon icon={faWarning}/>
            {props.title}
          </div>
        </div>
      </div>
  );
}
